import { Stack, Tabs, Title } from '@mantine/core'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { FabricTableWithProduct } from 'components/advancedSearch/FabricTableWithProduct'
import { PillowTableWithProduct } from 'components/advancedSearch/PillowTableWithProduct'
import { PremadeTableWithProduct } from 'components/advancedSearch/PremadeTableWithProduct'
import { TableTableWithProduct } from 'components/advancedSearch/TableTableWithProduct'
import { TowelTableWithProduct } from 'components/advancedSearch/TowelTableWithProduct'
import { variantsQuery } from 'hooks/products'
import { Category } from 'types/products'
import { categories, getCategoryName } from 'utils'

export const Route = createFileRoute('/_auth/advanced-search/{-$section}')({
  component: RouteComponent,
  beforeLoad: async ({ params, context: { queryClient } }) => {
    const { section } = params
    if (!section) {
      throw redirect({ to: `/advanced-search/${Category.PREMADE}` })
    }
    return queryClient.ensureQueryData(
      variantsQuery({
        category: section as Category,
        columnFilters: [],
        sorting: [],
        pagination: { pageIndex: 0, pageSize: 15 },
      })
    )
  },
})

function RouteComponent() {
  const { section } = Route.useParams()
  const navigate = Route.useNavigate()

  return (
    <Stack gap="xl">
      <Title order={1}>Zaawansowane wyszukiwanie</Title>
      <Tabs value={section} onChange={(value) => value && navigate({ to: `../${value}` })}>
        <Tabs.List>
          {categories.map((category) => {
            return (
              <Tabs.Tab value={category} key={category}>
                {getCategoryName(category).header}
              </Tabs.Tab>
            )
          })}
        </Tabs.List>
        <Tabs.Panel value={Category.PREMADE}>
          <Stack gap="xl" mt="xl">
            <PremadeTableWithProduct />
          </Stack>
        </Tabs.Panel>
        <Tabs.Panel value={Category.FABRIC}>
          <Stack gap="xl" mt="xl">
            <FabricTableWithProduct />
          </Stack>
        </Tabs.Panel>
        <Tabs.Panel value={Category.PILLOW}>
          {' '}
          <Stack gap="xl" mt="xl">
            <PillowTableWithProduct />
          </Stack>
        </Tabs.Panel>
        <Tabs.Panel value={Category.TOWEL}>
          {' '}
          <Stack gap="xl" mt="xl">
            <TowelTableWithProduct />
          </Stack>
        </Tabs.Panel>
        <Tabs.Panel value={Category.TABLE}>
          {' '}
          <Stack gap="xl" mt="xl">
            <TableTableWithProduct />
          </Stack>
        </Tabs.Panel>
      </Tabs>
    </Stack>
  )
}
